// Dependencies
import React, { Component } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { StarRating } from '../../lib/StarRating';
import { rateExperience } from '../../actions/ActionTypes';
import colors from '../../theme/Colors';
import { AnalyticsManager, EventParameterKey, EventParameterValue, EventType } from '../../analytics';
import { isPresent } from '../../utils/BooleanUtility';

class RateExperienceCard extends Component {
  onFinishRating = (rating) => {
    const {
      itemData: {
        arguments: { entityType = '', entityId = '' } = {},
        extraArguments: { previousRating: { star = '' } = {} } = {},
      } = {},
      rateExperience,
    } = this.props;
    if (isPresent(star)) return null;
    AnalyticsManager.logEvent(EventType.routine.ITEM_CLICK, {
      [EventParameterKey.TYPE]: EventParameterValue.ITEM_TYPE.FEEDBACK,
      [EventParameterKey.NAME]: 'rate_experience',
      [EventParameterKey.ENTITY]: entityType,
      [EventParameterKey.ENTITY_ID]: entityId,
    });
    const body = {
      entityType,
      entityId,
      rating,
    };
    rateExperience(body);
  };

  render() {
    const { itemData: { title = '', extraArguments: { previousRating: { star = '' } = {} } = {} } = {} } =
      this.props;
    return (
      <View style={styles.rateProductContainer}>
        <View style={styles.rateProductCard}>
          <Text style={styles.rateProductMessageText}>{title}</Text>
          <StarRating rating={star} count={5} defaultRating={0} size={45} onFinishRating={this.onFinishRating} />
        </View>
      </View>
    );
  }
}

const mapStateToProps = (store, ownProps) => {
  const { id } = ownProps;
  return {
    rating: !!store.UserAccountInfo.deliveryRatings[id] && store.UserAccountInfo.deliveryRatings[id],
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ rateExperience }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RateExperienceCard);

const styles = StyleSheet.create({
  rateProductContainer: {
    backgroundColor: colors.white,
    padding: 12,
    marginHorizontal: 12,
    borderRadius: 4,
    marginVertical: 12,
  },
  rateProductCard: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.white,
  },
  rateProductMessageText: {
    lineHeight: 17,
    fontFamily: 'Roboto-Medium',
    fontSize: 16,
    fontStyle: 'normal',
    letterSpacing: 0,
    color: colors.foxyBlack,
    alignSelf: 'flex-start',
  },
});
